<template>
    <span class="badge" :class="styleClass" v-if="expireIn !== null">{{badgeText}}</span>
</template>

<script>
    export default {
        props: {
            expireIn: {
                type: Number|null,
                required: false,
            },
        },
        computed: {
            styleClass() {
                if (this.expireIn <= 5 && this.expireIn >= 0) {
                    return 'badge-warning';
                } else if (this.expireIn < 0) {
                    return 'badge-danger';
                }
                return 'badge-light';
            },
            badgeText() {
                if (this.expireIn === 0) {
                    return this.t('Expire today');
                } else if (this.expireIn < 0) {
                    return this.t('Expired');
                }
                return this.tc('Expire in {count} days', this.expireIn);
            }
        },

    }
</script>



// WEBPACK FOOTER //
// src/pages/private/applications/expire-badge.vue